module.exports = __webpack_public_path__ + "components/rewards/coolbus/static/logo-63a26c2a2cc731bd5d434b730fcdc788.jpg";